import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild } from '@angular/core';
import { RecipientMaintenanceService } from 'src/app/pages/maintenance/recipient-maintenance/recipient-maintenance.service';
import { GroupMaintenanceService } from 'src/app/pages/maintenance/group-maintenance/group-maintenance.service';
import { debounceTime, filter, distinctUntilChanged, map, takeUntil, finalize, } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { of as observableOf, fromEvent, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-recipient-multiselect-dropdown',
  templateUrl: './recipient-multiselect-dropdown.component.html',
  styleUrls: ['./recipient-multiselect-dropdown.component.scss']
})
export class RecipientMultiselectDropdownComponent implements OnInit {
  @Input() textLabel;
  @Input() wrapperLayoutAlign;
  @Input() labelFlex;
  @Input() formWrapperFlex;
  @Input() previousData;
  @Input() selectedRecipient;
  @Input() groupMntDropdown;
  @Input() disabled;
  @Input() placeHolder;
  @Input() isRequired: Boolean = true;
  @Input() hasTextLabel: Boolean = true;
  @Output() recipientSelected = new EventEmitter;
  @ViewChild('chipsRecipient') chipsRecipient: MatChipList;
  
  @ViewChild('recipientAC') recipientAC: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) recipientACTr: MatAutocompleteTrigger;

  formGroup: FormGroup;
  originals = [];
  loading = {
    recipient: false,
    init: false,
    more: false,
    error: false
  };
  public recipients = [];
  private currentFilters;
  private listSub: Subscription;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  multiSelect = {
    selectedRecipients: [],
  }
  public defaultOption = {
    id: 0,
    reference_code: "all",
    fullname: "All",
    selected: false
  };

  constructor(
    private fb: FormBuilder,
    private helper: HelperService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public groupMntService: GroupMaintenanceService,
    public recipientService: RecipientMaintenanceService,
    ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  initForm() {
    this.formGroup = this.fb.group({
      recipient: [null, [Validators.required, this.helper.checkIfObject]]
    })

    if(this.selectedRecipient) {
      this.formGroup.get('recipient').setValue(this.selectedRecipient.map(e => { return e.id }));
      this.multiSelect.selectedRecipients = this.selectedRecipient;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes.selectedRecipient && !changes.selectedRecipient.firstChange) {
      this.formGroup.get('recipient').setValue(changes.selectedRecipient.currentValue, { emitEvent : false });
      if(!changes.selectedRecipient.currentValue) {
        this.multiSelect.selectedRecipients = [];
      }
    }

    if(changes && changes.selectedRecipient && !changes.selectedRecipient.firstChange) {
      this.currentFilters.web_filter.user_ids = [_.get(this.selectedRecipient, 'user_id') || 0]
    }
  }

  detectFormChanges() {
    this.formGroup.get('recipient').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.recipients = [];
      this.getListData();
    });
  }

  getInitialValues(data) {
    this.currentFilters.web_filter.offset = 0;
    this.currentFilters.web_filter.keyword = "";
    this.recipients = [];
    this.getListData();
  }

  getMoreData(name) {
    if (this.currentFilters.getMore) {
      this.currentFilters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getListData();
    }
  }

  getListData() {
    this.loading.recipient = true;
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.recipients.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    let filters = _.cloneDeep(this.currentFilters);
    let svcToUse = this.recipientService.getList(filters);
    
    if(this.groupMntDropdown) {
      filters.web_filter.drop_down = 1;
      filters.web_filter.group_filter_id = _.get(this.previousData, 'group_filter_id');
      svcToUse = this.groupMntService.getRecipients(filters)
    }

    this.listSub = svcToUse.pipe(
      finalize(() => {
        this.loading.recipient = false;
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.recipient = false;
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.recipients = [];
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.recipients[0] = this.defaultOption;
          this.recipients = this.recipients.concat(res.data);

          this.checkSelected('recipients', 'selectedRecipients', 'recipient');

          if((res.data.length > 0) && (this.recipients.length < _.get(res, 'count'))) {
            this.currentFilters.getMore = true;
          } 
        }

        if((_.toLower(_.get(res, 'value')) == "empty object") && (this.currentFilters.getMore == true)) {
          this.currentFilters.getMore = false;
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loading.recipient = false;
        if (this.recipients.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.limit -= this.currentFilters.web_filter.offset;
        }
        return observableOf(null);
      });
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return _.get(data, 'reference_code') + ' - ' + _.get(data, 'fullname');
    }
    return null;
  }

  autoCmpltClosed() {
    if (_.has(this.formGroup.get('recipient'), 'value') && _.isArray(_.get(this.formGroup.get('recipient'), 'value'))) {
      this.recipientSelected.next(_.get(this.formGroup.get('recipient'), 'value'))
    }
  }

  clearForm(ev: Event) {
    this.recipients = [];
    this.multiSelect.selectedRecipients = [];
    this.formGroup.get('recipient').setValue(null, {emitEvent: false});
    this.recipientSelected.next(null);
    ev.stopPropagation();
  }

  checkSelected(srcArray, targetArray, formControlName) {
    if(this.multiSelect[targetArray].some(opt => opt.fullname == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj.selected = false;
      this.toggleSelection(tempObj, this[srcArray], targetArray, formControlName, null);
    } 
    else if (this.multiSelect[targetArray].length) {
      this[srcArray].forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if(e.reference_code == v.reference_code) {
            e.selected = v.selected;
          }
        })
        if(e.fullname == 'All') {
          e.selected = false;
        }
      })
    } else {
      this[srcArray].forEach(e => {
        e.selected = false;
      })
    }
  }

  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }
 
  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    if(inputElem) {
      inputElem.value = '';
    }

    // console.log(data, srcArray, targetArray, formControlName, inputElem)
    data.selected = !data.selected;
 
    //if 'all' is selected, choose only all
    if(data.selected == true && data.reference_code == 'all') {
      srcArray.forEach(e => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    } 
 
    //if 'all' is deselected, unselect everything
    else if(data.selected == false && data.reference_code == 'all') {
      srcArray.forEach(e => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      this.enableCheckbox(srcArray);
    } 
 
    else if(this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.reference_code == data.reference_code)
      if(this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach(e => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      } 
      //if data exists in array, remove from list
      else if(this.multiSelect[targetArray].some(opt => opt.reference_code == data.reference_code)) {
        let index = _.findIndex(this.multiSelect[targetArray], function(item) { return item['reference_code'] == data.reference_code })
        this.multiSelect[targetArray].splice(index, 1);
      } 
      else {
        this.multiSelect[targetArray].push(data);
      }
    } 
    
    else {
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      srcArray.forEach(e => {
        if(e.id == data.id) {
          e.selected = false;
        }
      });
    }
  
    this.assignFormValues(targetArray, formControlName);
  }
 
  enableCheckbox(optionArray) {
    optionArray.forEach(e => {
      e.disabled = false;
    })
  }
 
  disableCheckbox(optionArray, formControlName, data) {
    if (optionArray[0].selected && (_.has(this.formGroup.get(formControlName), 'value') && this.formGroup.get(formControlName).value == 0) || (_.get(data, 'reference_code') == 'all')) {
      optionArray.forEach(e => {
        if(e.reference_code != 'all') {
          e.disabled = true;
        }
      })
    } else {
      this.enableCheckbox(optionArray);
    }
  }
 
  assignFormValues(targetArray, formControlName) {
    let tempArr;
    tempArr = this.multiSelect[targetArray].map(e => {
      return e.id;
    });
    this.formGroup.get(formControlName).setValue(tempArr);
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }
  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && control.controls[objectKey].value != "") {
      control.controls[objectKey].setErrors({
        "notExisting": true
      });
    }

    if(_.size(this.multiSelect[targetArray]) && targetArray) {
      // control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: "",
    end_date: "",
    status: null,
    is_asc: 1,
    drop_down: 0,
    is_dropdown: 1
  }
}